import { html } from './html.js';

/**
 * Faixas com rolagem horizontal (garagem e oficinas no Início, filtros e fotos da vitrine) no navegador com mouse.
 * No toque o navegador já rola sozinho; com mouse não (a barra fica escondida). Aqui:
 *   - arrastar com o mouse rola a faixa; se arrastou, o clique do fim não abre o cartão
 *   - setas ‹ › (hsArrows) para quem usa mouse: o CSS só mostra em telas com hover
 * Ligado uma vez no documento (main.js): vale para todas as telas e para o HTML redesenhado.
 */
const SCROLLERS = '.hscroll, .chips, .gallery';

export function enableHScroll(root = document) {
  let drag = null;

  root.addEventListener('pointerdown', (e) => {
    if (e.pointerType !== 'mouse' || e.button !== 0 || e.target.closest('[data-hs]')) return;
    const el = e.target.closest(SCROLLERS);
    if (el && el.scrollWidth > el.clientWidth) drag = { el, x: e.clientX, left: el.scrollLeft, moved: false, id: e.pointerId };
  });

  root.addEventListener('pointermove', (e) => {
    if (!drag || e.pointerId !== drag.id) return;
    const dx = e.clientX - drag.x;
    if (!drag.moved) {
      if (Math.abs(dx) < 6) return; // clique com a mão tremendo continua sendo clique
      drag.moved = true;
      drag.el.classList.add('dragging'); // sem snap enquanto arrasta; ao soltar, encaixa no cartão mais perto
      drag.el.setPointerCapture?.(e.pointerId);
    }
    drag.el.scrollLeft = drag.left - dx;
  });

  const end = (e) => {
    if (!drag || e.pointerId !== drag.id) return;
    const { el, moved } = drag;
    drag = null;
    if (!moved) return;
    el.classList.remove('dragging');
    // o clique que o navegador dispara ao soltar não abre o cartão/foto
    const block = (ev) => {
      ev.stopPropagation();
      ev.preventDefault();
    };
    window.addEventListener('click', block, { capture: true, once: true });
    setTimeout(() => window.removeEventListener('click', block, { capture: true }), 0);
  };
  root.addEventListener('pointerup', end);
  root.addEventListener('pointercancel', end);

  // imagens e links não "saem voando" ao arrastar
  root.addEventListener('dragstart', (e) => {
    if (e.target.closest?.(SCROLLERS)) e.preventDefault();
  });

  // setas: rolam quase uma tela; somem no começo/fim
  root.addEventListener('click', (e) => {
    const b = e.target.closest?.('[data-hs]');
    if (!b) return;
    const el = b.parentElement.querySelector(SCROLLERS);
    el?.scrollBy({ left: Number(b.dataset.hs) * el.clientWidth * 0.85, behavior: 'smooth' });
  });
  const edges = (el) => {
    const wrap = el.parentElement;
    if (!wrap?.classList.contains('hs-wrap')) return;
    wrap.classList.toggle('at-start', el.scrollLeft <= 2);
    wrap.classList.toggle('at-end', el.scrollLeft + el.clientWidth >= el.scrollWidth - 2);
  };
  root.addEventListener('scroll', (e) => e.target.matches?.(SCROLLERS) && edges(e.target), true);
  root.addEventListener('pointerover', (e) => {
    const wrap = e.target.closest?.('.hs-wrap');
    const el = wrap?.querySelector(SCROLLERS);
    if (el) edges(el);
  });
}

/** Setas ‹ › da faixa (ficam dentro do .hs-wrap, junto da faixa). */
export const hsArrows = () => html`
  <button type="button" class="hs-btn prev" data-hs="-1" aria-label="Anterior"><ion-icon name="chevron-back"></ion-icon></button>
  <button type="button" class="hs-btn next" data-hs="1" aria-label="Próximo"><ion-icon name="chevron-forward"></ion-icon></button>`;
